<template>
  <vs-row vs-justify="center" id="organization-box">
    <vs-col type="flex" vs-lg="12" vs-xs="12">
      <vs-card id="form" fixedHeight>
        <vs-row class="mt-4">
              <vs-col vs-lg="12" vs-xs="12" vs-sm="12" class="w-75" style="margin-left: auto; margin-right: auto;">
                <vs-row>
                  <vs-col vs-w="3"></vs-col>
                  <vs-col vs-w="6">
                    <vs-input
                            :label="$t('Organization.Cover')"
                            v-model="cover_photo"
                            class="w-100 mb-2"
                            id="fileInputCover"
                            type="file"
                    />
                  </vs-col>
                </vs-row>
                <vs-row>
                  <vs-col vs-w="6">
                    <vs-input
                            :label="$t('Organization.Logo')"
                            v-model="logo"
                            class="w-100 mb-2"
                            id="fileInput"
                            type="file"
                    />
                  </vs-col>
                  <vs-col vs-w="6">
                    <vs-input
                            :label="$t('Organization.SMSSenderName')"
                            v-model="sms_sender_name"
                            class="w-100 mb-2"
                    />
                  </vs-col>
                </vs-row>

                <vs-row>
                  <vs-col vs-w="6">
                    <vs-input
                            :label="$t('Organization.Name')"
                            v-model="name"
                            class="w-100 mb-2"
                    />
                  </vs-col>
                  <vs-col vs-w="6">
                    <vs-input
                            :label="$t('Organization.Email')"
                            v-model="email"
                            class="w-100 mb-2"
                    />
                  </vs-col>
                </vs-row>
                <vs-row>
                  <vs-col vs-w="6">
                    <vs-input
                            :label="$t('Organization.Address')"
                            v-model="address"
                            class="w-100 mb-2 mt-2"
                    />
                  </vs-col>
                  <vs-col vs-w="6">
                    <vs-input
                            :label="$t('Organization.Phone')"
                            v-model="phone"
                            class="w-100 mt-2"
                    />
                  </vs-col>
                  <vs-col vs-w="6">
                                <vs-select
                                        class="w-100 mt-2"
                                        size="large"
                                        :placeholder="$t('Company.Industry')"
                                        :label="$t('Company.Industry')"
                                        v-model="industry_id"
                                >
                                  <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in industries" />
                                </vs-select>
                  </vs-col>
                  <vs-col vs-w="6">
                                <vs-input
                                        :label="$t('Organization.Mlbrx_Short_Link')"
                                        v-model="short_link"
                                        class="w-100 mt-2"
                                />
                              </vs-col>
                </vs-row>
                <vs-row>
                  <vs-col vs-w="2" style="margin-left: auto; margin-right: auto;">
                      <label class="vs-input--label" for="color-add-edit">{{$t('Department.Color')}}</label>
                      <input id="color-add-edit" v-model="template" type="color" class="w-100"/>
                  </vs-col>

                  <vs-col vs-w="2" style="margin-left: auto; margin-right: auto;">
                      <label class="vs-input--label" for="color-add-edit">{{$t('Department.FontColor')}}</label>
                      <input id="color-add-edit" v-model="font_color" type="color" class="w-100"/>
                  </vs-col>
                  <!-- <vs-col vs-w="4" style="margin-left: auto; margin-right: auto;">
                      <vs-input type="file" class="w-100" @change="handleChangePhoto" id="fileInput" :label="$t('Organization.Logo')" v-model="logo"/>
                  </vs-col> -->
                </vs-row>
              </vs-col>
            </vs-row>
            <br>
            <vs-row> 
                <GmapMap
                        :center="currentLocation"
                        :zoom="16"
                        map-type-id="terrain"
                        style="width: 100%; height: 400px"
                        :options="{
                          zoomControl: true,
                          mapTypeControl: false,
                          streetViewControl: false,
                          rotateControl: false,
                          fullscreenControl: true,
                          disableDefaultUi: false
                        }"
                >
                <GmapMarker
                        :position="marker"
                        :clickable="true"
                        :draggable="true"
                        @dragend="updateCoordinates"
                />
                </GmapMap>
            </vs-row>
            <vs-row class="float-right m-4" >
                  <vs-button color="primary" @click="createOrganization">{{$t('Organization.CreateButton')}}</vs-button>
            </vs-row>

      </vs-card>
    </vs-col>   
  </vs-row>
</template>

<script>
import { gmapApi } from 'vue2-google-maps'
import router from "../../_helpers/router";
import { organizationService, helpersService } from "../../_services";


export default {
  name: "organization-box",
  data: () => ({
        title: "Create organization",
        currentLocation: {lat: 0, lng: 0},
        marker: {lat: 0.0, lng: 0.0},        
        name: '',
        email: '',
        logo: '',
        cover_photo: '',
        sms_sender_name: '',
        address: '',
        phone: '',
        template: '',
        font_color: '',
        photo: '',
        industry_id: '',
        errors: {
          firstname: false,
          lastname: false,
          email: false,
          phone: false,
          photo: false,
          isModalVisible: false,

        },
        industries: [],
        short_link: null
  }),
  computed : {
    google: gmapApi,
  },
  methods: {
    notify(title, text, type) {
      this.$vs.notify({
        title: title,
        text: text,
        color: type
      });
    },


    createOrganization(){
      this.$vs.loading({
        container: '#organization-box',
        scale: 0.6
      });

      try{
        let organization = new FormData()
        organization.append('name',this.name);
        organization.append('email',this.email);
        organization.append('phone',this.phone);
        organization.append('industry_id',this.industry_id);
        organization.append('address', this.address);
        organization.append('template', this.template);
        organization.append('font_color', this.font_color);
        organization.append('lat', this.marker.lat);
        organization.append('lng', this.marker.lng);
        organization.append('sms_sender_name', this.sms_sender_name);
        organization.append('short_link',this.short_link);
        if(document.getElementById("fileInput").files[0]){
          organization.append('logo', document.getElementById("fileInput").files[0]);
        }
        if(document.getElementById("fileInputCover").files[0]){
          organization.append('cover_photo', document.getElementById("fileInputCover").files[0]);
        }

        organizationService.create(organization).catch(function () {
        }.bind(this)).finally(function () {
            this.$vs.loading.close('#organization-box > .con-vs-loading');
            this.notify(
              this.$t("Toasts.Successful"),
              this.$t("Organization.OrganizationAdd.ToastSuccessMessage"),"success"
            );
            this.$router.push('/organizations')
          }.bind(this));
          } catch (e) {
              this.$vs.loading.close('#organization-box > .con-vs-loading');
              this.notify(
                this.$t("Toasts.Error"),
                this.$t("Organization.OrganizationAdd.ToastFailMessage"),"danger");
            }
      },
      geolocation : function() {
        navigator.geolocation.getCurrentPosition((position) => {
          this.currentLocation = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          };
          this.marker = this.currentLocation;
        });
      },
      updateCoordinates(location) {
        this.marker = { lat: location.latLng.lat(), lng: location.latLng.lng() };
      },
  },
  mounted() {
      helpersService.getIndustries().then(function (data) {
        this.industries = [];
        data.industries.forEach(obj => {
          this.industries.push({
            value: obj.id,
            text: obj.name
          });
        })
      }.bind(this));
  }
}
</script>

<style>

</style>